import { Box, Menu, MenuButton, MenuButtonProps, MenuItem, MenuList, Text } from "@chakra-ui/react"
import React from "react"

import { Account, DisconnectButton, WalletButton } from "../module/account"
import { SUPPORTED_WALLETS, WalletInfo } from "../module/account/constant"
import { getShortenAddress } from "../util/stringEdit"

interface ConnectBtnProps extends MenuButtonProps {
    shouldShortenAddress?: boolean
    connectBtnText?: string
}

export function ConnectBtn({ shouldShortenAddress = true, connectBtnText, ...rest }: ConnectBtnProps) {
    const { account, isTesting } = Account.useContainer()

    if (isTesting) {
        return (
            <Box>
                You're testing on <Text color="orange">{account}</Text>
            </Box>
        )
    }
    const addressStr = shouldShortenAddress ? getShortenAddress(account || "") : account

    return (
        <Menu autoSelect={false} closeOnSelect>
            <MenuButton
                borderRadius="full"
                overflow="hidden"
                bgColor={account ? "rgba(255, 255, 255, 0.16)" : "orange.400"}
                p="8px 16px"
                fontWeight="600"
                {...rest}
            >
                {account ? addressStr : connectBtnText || "Connect"}
            </MenuButton>
            <MenuList minWidth="260px">
                {SUPPORTED_WALLETS.map((value: WalletInfo) => {
                    return (
                        <MenuItem key={value.type} as={Box}>
                            <WalletButton type={value.type} name={value.name} connector={value.connector} />
                        </MenuItem>
                    )
                })}
                {account && (
                    <MenuItem as={Box}>
                        <DisconnectButton />
                    </MenuItem>
                )}
            </MenuList>
        </Menu>
    )
}
